<template>
    <div>
        <v-card>
            <v-card-title v-if="title">
                {{ title }}
            </v-card-title>
            <v-card-text>
                <div>
                    <div v-if="versionOptions.length > 0" class="mt-2 mb-2">
                        <v-select v-model="selectedVersion" :items="versionOptions" :label="$t('Versio')" outlined dense
                            style="max-width: 200px;"></v-select>
                    </div>
                </div>

                <v-tabs v-model="activeTab">
                    <v-tab>{{ $t('Lukukuittaus saatu') }}</v-tab>
                    <v-tab>{{ $t('Ei lukukuittausta') }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="activeTab">
                    <v-tab-item>
                        <div class="pt-4">
                            <AcknowledgmentList :target-type="targetType" :target-id="targetId" :acknowledged="true"
                                :version="selectedVersion" />
                        </div>
                    </v-tab-item>
                    <v-tab-item>
                        <div class="pt-4">
                            <AcknowledgmentList v-if="activeTab === 1" :target-type="targetType" :target-id="targetId"
                                :acknowledged="false" :version="selectedVersion" />
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { ref, computed, watch } from "@vue/composition-api";
import AcknowledgmentList from "./AcknowledgmentList.vue";


export default {
    components: {
        AcknowledgmentList,
    },
    props: ["targetId", "targetType", "version", "title"],
    setup(props) {
        const activeTab = ref(0);
        const selectedVersion = ref(props.version);

        // Generate version options (only if version > 1)
        const versionOptions = computed(() => {
            if (!props.version || props.version <= 1) return [];
            return Array.from({ length: props.version }, (_, i) => ({
                text: `v${i + 1}`,
                value: i + 1
            }));
        });

        // Watch for version prop changes
        watch(() => props.version, (newVersion) => {
            selectedVersion.value = newVersion;
        });

        return {
            activeTab,
            selectedVersion,
            versionOptions,
        };
    },
};
</script>
